import { getUserRight } from "@/sideEffects/api";
import { appActions } from "@/store/appSlice";
import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { getToken } from "@/sideEffects/persist/authSideEffects";

export const useUser = () => {
  const dispatch = useDispatch();
  const userRight = useQuery({
    queryKey: ["getUserRight"],
    queryFn: getUserRight,
    retry: false,
    // We force the query to be stale indefinetely
    staleTime: Infinity,
  });

  const token = getToken();
  // @ts-ignore
  const jwtUserId = token ? jwtDecode(token).Id : null;

  const logout = () => {
    dispatch(appActions.triggerLogout());
    document.location.href = "/";
  };

  return {
    user: userRight.data?.data,
    isLoading: userRight.isLoading,
    isError: userRight.isError,
    logout,
    jwtUserId: jwtUserId,
  };
};
